import type { IntegrationRequestFormSchema } from '../../../../models/IntegrationRequest';
import type { ShippingStatus } from '@/pages/Business/pages/LogisticOperator/models';
import { WebhookHeadersField } from '../../../../components';
import { FormCheckbox, FormTextInput } from '@/components';
import WebhookStatusesField from './WebhookStatusesField';
import type { Control } from 'react-hook-form';
import FormSection from './FormSection';

interface WebhookSectionProps {
  control: Control<IntegrationRequestFormSchema>;
  statuses: ShippingStatus[];
  isApi: boolean;
  showsWebhook: boolean;
  disabled: boolean;
}

const WebhookSection = ({
  control,
  statuses,
  isApi,
  showsWebhook,
  disabled,
}: WebhookSectionProps) => (
  <FormSection title='Webhook de estados'>
    {isApi && (
      <FormCheckbox
        control={control}
        name='withWebhook'
        placeholder='El cliente quiere recibir los cambios de estado por webhook'
        disabled={disabled}
      />
    )}
    {showsWebhook && (
      <>
        <FormTextInput
          control={control}
          name='webhookUrl'
          placeholder='URL del webhook (https://...)'
          required
          disabled={disabled}
        />
        <WebhookHeadersField control={control} name='webhookHeaders' disabled={disabled} />
        <WebhookStatusesField control={control} statuses={statuses} disabled={disabled} />
      </>
    )}
  </FormSection>
);

export default WebhookSection;
